<template>
  <div>
    <b-modal
      centered
      id="modal-edit-casa"
      hide-footer
      header-class="no-border"
      body-class="no-border"
      modal-class="modalStyle"
      ref="modal-edit-casa"
    >
      <div class="modalBody">
        <b-row class="formsArea">
          <b-form @submit.prevent="handleSubmit">
            <label class="mt-3 labels">Nome da Casa</label>
            <b-form-input
              type="text"
              v-model="house_name"
              :state="validateState('house_name')"
              aria-describedby="input-nome-feedback"
            ></b-form-input>
            <b-form-invalid-feedback id="input-nome-feedback"
              >Campo obrigatório</b-form-invalid-feedback
            >
          </b-form>

          <b-form @submit.prevent="handleSubmit">
            <label class="mt-3 labels">Código da Casa</label>
            <b-form-input type="text" v-model="house_code"></b-form-input>
          </b-form>

          <b-form @submit.prevent="handleSubmit">
            <label class="mt-3 labels">Composto da Casa</label>
            <b-form-select
              v-model="compound_id"
              :options="[
                { id: '', compound_number: 'Sem composto' },
                ...compounds,
              ]"
              value-field="id"
              text-field="compound_number"
            >
            </b-form-select>
          </b-form>
        </b-row>
      </div>

      <div class="modalFooter">
        <b-row class="alinhamentoLinha">
          <b-button class="button btn-cancel" @click="openModal(false)"
            >Cancelar</b-button
          >
          <b-button
            class="button btn-save"
            type="submit"
            variant="primary"
            @click="handleSubmit"
            >Salvar</b-button
          >
        </b-row>
      </div>
    </b-modal>
    <ModalConfirmation
      :isConfirm="isConfirm"
      @responseModal="responseModal($event)"
    />
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { Compounds } from '../../services/Compound';
import { EditHouse } from '../../services/House';
import ModalConfirmation from '../ModalConfirmation.vue';

export default {
  components: { ModalConfirmation },
  data() {
    return {
      compounds: [],
      compound_id: '',
      house_id: '',
      house_name: '',
      house_code: '',
      isConfirm: true,
    };
  },
  validations: {
    house_name: {
      required,
    },
  },
  props: {
    house: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    validateState(type) {
      const field = this.$v[type];
      if (field) {
        const { $dirty, $error } = field;
        return $dirty ? !$error : null;
      }
      return null;
    },
    handleSubmit() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      this.openModal(true);
    },
    openModal(isConfirm) {
      this.isConfirm = isConfirm;
      this.$bvModal.show('modal-confirmation');
    },

    responseModal(event) {
      if (event) {
        const id = this.house_id;
        const data = {};

        if (this.house_name) {
          data.house_name = this.house_name;
        }
        if (this.house_code) {
          data.house_code = this.house_code;
        }
        if (this.compound_id) {
          data.compound_id = this.compound_id;
        }

        EditHouse(id, data).then(() => {
          this.$toasted.global.defaultSuccess();
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        });
      }
      this.$bvModal.hide('modal-confirmation');
      this.$bvModal.hide('modal-edit-casa');
    },
  },
  created() {
    Compounds().then((response) => {
      response.data.forEach((compound) => {
        if (!compound.is_discarded) {
          this.compounds.push(compound);
        }
      });
    });
    this.house_id = this.house.id;
    this.house_name = this.house.house_name;
    this.house_code = this.house.house_code;
    if (this.house.compound) {
      this.compound_id = this.house.compound.id;
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .no-border {
  border: none;
}
::v-deep .modalStyle > .modal-dialog > .modal-content {
  background-color: #be8250;
  border-radius: 20px;
  color: #eeeeee;
}

// ::v-deep .custom-select {
//   background-color: #eeeeee;
//   border-radius: 11px;
//   width: 400px;
// }

.custom-select {
  background-color: #eeeeee;
  border-radius: 11px;
  width: 350px;
  display: flex;
}
.modalBody {
  font-family: 'Inter', sans-serif;
  //   display: grid;
  //   grid-template-columns: 1fr 2fr;
  //   grid-gap: 20px;
}
.cursor {
  cursor: pointer;
}

.horizontal-inputs {
  margin-bottom: 20px;
}

.formsArea {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: -20px;
}
.form-control {
  background-color: #eeeeee;
  border-radius: 11px;
  width: 350px;
}

.modalFooter {
  margin-top: 30px;
}
.alinhamentoLinha {
  display: flex;
  justify-content: flex-end;
  margin-right: 0.5rem !important;
}
.button {
  height: 32px;
  cursor: pointer;
  color: #ffffff;
  border-radius: 22px;
  border: none;
  width: 124px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
}
.btn-cancel {
  background-color: #d12c38;
}
.btn-save {
  background-color: #169933;
  margin-left: 18px;
}
</style>
